export const getFromSearchString = (key: string) => {
  const searchString = window.location.search;
  const urlSearchParams = new URLSearchParams(searchString);
  const answerId = urlSearchParams.get(key);
  return answerId;
};
